var context = import.meta.glob("../components/**/*.{js,jsx}", { eager: true });

let componentsContext = {};
for (const component in context) {
  componentsContext[component.replace(".jsx", "").replace(/.+components\//g, "")] =
    context[component].default;
}

import ReactRailsUJS from "react_ujs";
import "./i18n";

ReactRailsUJS.getConstructor = (name) => {
  return componentsContext[name];
};

import Landing from "@/javascript/Views/Landing.js";
window.Landing = Landing;
